'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import Vue from 'vue';
import VueMask from 'v-mask';
import Event from './event';
import Config from '../config';
import Module from '../modules/';
import components from '../modules/components';

var _class = function () {
    function _class() {
        _classCallCheck(this, _class);

        this.token = document.head.querySelector('meta[name="csrf-token"]').content;
        this.event = new Event();
        this.config = Config;
        this.countries = [];
        this.user = [];

        Vue.use(VueMask);

        this.slick = new Module.Slick();
        this.header = new Module.Header();
        this.magnificPopup = new Module.MagnificPopup();

        new Module.AddToCart();
        new Module.CartSmall();
        new Module.CartNumItems();
        new Module.CartTotal();
        new Module.Checkout();
        new Module.PasswordChange();

        new Module.ContactForm();
    }

    _createClass(_class, [{
        key: 'init',
        value: function init(url) {
            var _this = this;

            this.url = url.replace(/\/+$/, "");

            // - Trigger cookie consent banner.
            cookieconsent.initialise(Config.cookieconsent);

            this.slick.init();
            this.header.init();
            this.magnificPopup.init();

            this.fetchUser().then(function () {
                _this.vue = new Vue({
                    el: '#app',
                    components: components
                });
                _this.cartData();
                if ($('.popup-gallery').length) {
                    $('.popup-gallery').magnificPopup({
                        delegate: 'a',
                        type: 'image',
                        tLoading: 'Loading image #%curr%...',
                        mainClass: 'mfp-img-mobile',
                        gallery: {
                            enabled: true,
                            navigateByImgClick: true,
                            preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
                        },
                        image: {
                            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                            titleSrc: function titleSrc(item) {
                                return item.el.attr('title');
                            }
                        }
                    });
                }
            });

            this.fetchCountries();
        }
    }, {
        key: 'cartData',
        value: function cartData() {
            var _this2 = this;

            new Form().get('/api/cart/content').then(function (response) {
                _this2.event.fire('cart.data.loaded', response);
            });
        }
    }, {
        key: 'fetchCountries',
        value: function fetchCountries() {
            var _this3 = this;

            new Form().get('/register/countries').then(function (countries) {
                _this3.countries = countries;
                _this3.event.fire('countries.loaded', countries);
            });
        }
    }, {
        key: 'fetchUser',
        value: function fetchUser() {
            var _this4 = this;

            return new Form().get('/api/me').then(function (user) {
                return _this4.user = user;
            });
        }
    }]);

    return _class;
}();

export default _class;


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/core/app.js
// module id = +Cs5
// module chunks = 4